import { Location } from '@angular/common';
import { Component } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { PremiseService } from '../_services/premise.service';
import { faCircleArrowLeft, faHomeAlt } from '@fortawesome/free-solid-svg-icons';
import { PremiseAssociation } from '../_models/premise_association';
import { environment } from '../../environments/environment';
import { Breach, BreachService } from '../_services';
import { forkJoin } from 'rxjs';

interface BreachRow extends Breach {
  updatedAt?: string;
}

@Component({
  selector: 'app-breaches',
  standalone: false,

  templateUrl: './breaches.component.html',
  styleUrl: './breaches.component.css'
})
export class BreachesComponent {
  faCircleArrowLeft = faCircleArrowLeft;
  faHomeAlt = faHomeAlt;

  loading = false;
  premiseAssociations: PremiseAssociation[] = [];
  breaches: BreachRow[] = [];

  propertyName = '';
  unitNumberLabel = '';

  constructor(private toastr: ToastrService,
    private premiseService: PremiseService,
    private breachService: BreachService,
    private _location: Location,
    private router: Router) {

    }

    ngOnInit(): void {
      this.loading = true;
      this.premiseService.fetchUserAssociation().subscribe({
            next: (data) => {
              this.premiseAssociations = data || [];

              if (this.premiseAssociations.length === 0) {
                this.loading = false;
                this.router.navigate(['/premises/noassociation'])
                return;
              }

              this.propertyName = this.premiseAssociations.length === 1
                ? localStorage.getItem('currentProperty')
                  ? JSON.parse(localStorage.getItem('currentProperty') || '{}').name || ''
                  : ''
                : 'Multiple Properties';

              this.unitNumberLabel = this.premiseAssociations.length === 1
                ? String(this.premiseAssociations[0].unit_number)
                : 'Multiple Units';

              const breachRequests = this.premiseAssociations.map((association) =>
                this.breachService.getBreachesByPropertyIdAndUnitNumber(association.propertyId, association.unit_number)
              );

              forkJoin(breachRequests).subscribe({
                next: (breachGroups: BreachRow[][]) => {
                  this.breaches = breachGroups.flat();
                  this.loading = false;
                },
                error: (error: HttpErrorResponse) => {
                  this.loading = false;
                  this.toastr.error('Failed to retrieve breaches.', 'Error');
                  if (!environment.production) {
                    console.log('Breaches fetch error: ', error);
                  }
                }
              });
            },
            error: (error: HttpErrorResponse) => {
              this.loading = false;
              if (!environment.production) {

                console.log(error);
                this.toastr.error('Something went wrong. Fail to fetch associated premises. Please try again later or contact support if the issue persists.', 'Error');
              }
            }
          });


    }


    goBack() {
      this._location.back();
    }


    goHome(): void {
      this.router.navigate(['/home'])
    }
}
